/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from 'react'
import { cloudhelpGet } from 'Utilities/CloudHelp'

import Coverage from './Coverage'
import MicrosoftManagement from './MicrosoftManagement'
import { isManaged365Contract, textToBoolean } from './utilities'
import { partition } from 'lodash'

const CustomerContract = ({ ...customerContract }) => {
  const [assets, setAssets] = useState([])
  const [loadingAssets, setLoadingAssets] = useState(true)

  useEffect(() => {
    cloudhelpGet(`/api/contracts/${customerContract.id}/assets`)
      .then(({ data }) => {
        setAssets(data)
        setLoadingAssets(false)
      })
  }, [])

  const [defaultRulesAssets, specifiedRulesAssets] = partition(assets, asset => (
    textToBoolean(asset.antivirus_coverage) === customerContract.managed_antivirus &&
    textToBoolean(asset.patching_coverage) === customerContract.managed &&
    textToBoolean(asset.monitoring_coverage) === customerContract.managed &&
    textToBoolean(asset.data_protection_coverage) === customerContract.backup
  ))

  const assetRuleTypes = useMemo(() => [
    {
      label: 'Default coverage rules',
      assets: defaultRulesAssets,
      trueColor: 'grey',
      falseColor: 'grey'
    },
    {
      label: 'Specified coverage rules',
      assets: specifiedRulesAssets
    }
  ], [defaultRulesAssets, specifiedRulesAssets])

  const calligoDeviceTypes = [
    { label: 'Virtual Machine', name: 'virtual_machine' },
    { label: 'Desktop', name: 'desktop' },
    { label: 'Network Device', name: 'network_device' },
    { label: 'Physical Server', name: 'physical_server' },
    { label: 'Storage', name: 'storage' }
  ]

  if (customerContract.service_contract_template_id === 4) {
    return (
      <MicrosoftManagement {...{ customerContract }} />
    )
  }

  return (
    <Coverage {...{
      customerContract, assetRuleTypes, calligoDeviceTypes, loadingAssets
    }}
    />
  )
}

export default CustomerContract
